import { Franchise } from "./views/landingPages";

const App = () => {
	return <Franchise />;
};

export { App };
export default App;
